import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "buttons"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)

import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store";
import { Blog as BlogModel } from "@/models/blog";
import Blog from "./Blog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Blogs',
  setup(__props) {

const store = useStore();
const router = useRouter();
const blogs = computed<BlogModel[]>(() => store.state.blogs);
const auth = computed(() => store.state.auth);

onMounted(() => {
  store.dispatch(Actions.GetBlogs);
});

const addBlog = () => {
  router.push("/blog/add");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (auth.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "option",
            onClick: addBlog
          }, [
            _hoisted_2,
            _createTextVNode(" Add blog ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogs.value, (blog) => {
      return (_openBlock(), _createBlock(Blog, {
        blog: blog,
        listed: ""
      }, null, 8, ["blog"]))
    }), 256))
  ], 64))
}
}

})